import { useNotificationStore, Toast } from '../stores/notificationStore';

const TYPE_STYLE: Record<string, { border: string; titleColor: string; icon: string }> = {
  attack_in:          { border: '#ef4444', titleColor: '#f87171', icon: '⚠' },
  attack_out:         { border: '#22c55e', titleColor: '#4ade80', icon: '⚡' },
  mission_complete:   { border: '#38bdf8', titleColor: '#7dd3fc', icon: '✓' },
  mission_expired:    { border: '#6b7280', titleColor: '#9ca3af', icon: '⌛' },
  mission_cancelled:  { border: '#6b7280', titleColor: '#9ca3af', icon: '✖' },
  minigame_reward:    { border: '#38bdf8', titleColor: '#7dd3fc', icon: '🎮' },
  ip_change_complete: { border: '#a78bfa', titleColor: '#c4b5fd', icon: '●' },
  download_complete:  { border: '#f59e0b', titleColor: '#fbbf24', icon: '↓' },
  software_run:       { border: '#4ade80', titleColor: '#86efac', icon: '▶' },
  software_stop:      { border: '#f97316', titleColor: '#fdba74', icon: '■' },
};

const fallbackStyle = { border: '#4ade80', titleColor: '#4ade80', icon: '•' };

function ToastCard({ toast, onDismiss }: { toast: Toast; onDismiss: () => void }) {
  const style = TYPE_STYLE[toast.type] ?? fallbackStyle;

  return (
    <div
      style={{
        display: 'flex',
        flexDirection: 'column',
        gap: '0.2rem',
        background: '#0d1117',
        border: `1px solid ${style.border}`,
        borderLeft: `4px solid ${style.border}`,
        borderRadius: '4px',
        padding: '0.6rem 0.9rem',
        minWidth: '280px',
        maxWidth: '380px',
        boxShadow: `0 2px 12px ${style.border}33`,
        fontFamily: 'monospace',
        animation: 'slideIn 0.2s ease',
        position: 'relative',
      }}
    >
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <span style={{ color: style.titleColor, fontWeight: 'bold', fontSize: '0.8rem', letterSpacing: '0.05em' }}>
          {style.icon} {toast.title}
        </span>
        <button
          onClick={onDismiss}
          style={{
            background: 'none', border: 'none', color: '#555',
            cursor: 'pointer', fontSize: '0.85rem', lineHeight: 1, padding: '0 0 0 0.5rem',
          }}
          aria-label="Dismiss"
        >
          ×
        </button>
      </div>
      <span style={{ color: '#9ca3af', fontSize: '0.78rem', lineHeight: '1.4' }}>
        {toast.message}
      </span>
    </div>
  );
}

export default function NotificationToast() {
  const { toasts, dismiss } = useNotificationStore();

  if (toasts.length === 0) return null;

  return (
    <>
      <style>{`
        @keyframes slideIn {
          from { opacity: 0; transform: translateX(20px); }
          to   { opacity: 1; transform: translateX(0); }
        }
      `}</style>
      <div
        style={{
          position: 'fixed',
          bottom: '1.5rem',
          right: '1.5rem',
          display: 'flex',
          flexDirection: 'column-reverse',
          gap: '0.6rem',
          zIndex: 1000,
          pointerEvents: 'none',
        }}
      >
        {toasts.map(t => (
          <div key={t.id} style={{ pointerEvents: 'auto' }}>
            <ToastCard toast={t} onDismiss={() => dismiss(t.id)} />
          </div>
        ))}
      </div>
    </>
  );
}
